<template>
	<div class="w1200 flex flex-direction align-stretch benben-flex-layout bind">
	    <div class="flex bind_1">
	    	<div class="flex benben-flex-layout flex-wrap align-center pointer " @click="caozuo(1,1)">
	    		<img class="bind_1_1" src="https://api.ezlunch.club/pc/image/13.png" alt="" srcset="">
	    		<div class="bind_1_2">{{$t('返回')}}</div>
	    	</div>
	    </div>
		
		<div v-if="tab_type == 1">
			<div class="myNew_1">{{$t('我的消息')}}</div>
			<div class="flex myNew_2">
				<div @click="caozuo(2,1)" class="pointer myNew_2_3" :class="tabs == 1 ? 'myNew_2_1' : 'myNew_2_2'">{{$t('平台公告')}}</div>
				<div @click="caozuo(2,2)" class="pointer" :class="tabs == 2 ? 'myNew_2_1' : 'myNew_2_2'">{{$t('订单通知')}}</div>
			</div>
			<div v-loading="loading"  :element-loading-text="$t('拼命加载中')">
				<template v-for="(item,index) in order_list">
					<div class="myNew_3 pointer" @click="caozuo(3,item)">
						<div class="flex">
							<div class="flex-sub myNew_3_1">{{item.title}}</div>
							<div class="myNew_3_2" v-if="tabs == 1">{{item.create_time}}</div>
							<div class="myNew_3_4" v-if="tabs == 2 && item.is_read==1">{{$t('已读')}}</div>
							<div class="myNew_3_5" v-if="tabs == 2 && item.is_read==0">{{$t('未读')}}</div>
						</div>
						<div class="myNew_3_3" v-if="item.content">{{item.content}}</div>
						<div class="myNew_3_3" v-if="tabs == 2">{{item.create_time}}</div>
					</div>
				</template>
				<div style="text-align: center;padding: 40px 0;" v-if="order_list.length == 0">
					<img style="width: 217px;height: 177px;" src="https://api.ezlunch.club/pc/image/29.png" alt="" srcset="">
				</div>
				<div v-if="order_list.length > 0" style="text-align: center;margin: 20px  0;">
					<el-pagination
					   @current-change="handleCurrentChange"
					   layout="prev, pager, next"
					   :current-page.sync="page" :page-size="page_size"
					   :total="total">
					 </el-pagination>
				</div>
			</div>
			
			
		</div>
		
		<div class="flex flex-direction align-center benben-flex-layout" v-if="tab_type == 2">
			<div class="myNew_4">{{detail.title}}</div>
		    <div class="myNew_5">{{detail.create_time}}</div>
			<div class="content-h" v-html="detail.content"></div>
		</div>
		
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				tabs:1,
				tab_type:1,
				detail:{
					content:''
				},
				total:0,
				page:1,
				page_size:10,
				loading:true,
				order_list:[],
				ping_id:'',
			}
		},
		created() {
			if(window.sessionStorage.getItem('token')){
				this.xiaoxilist()
			}else{
				this.$router.push({
					name: 'login',
				});
			}
		},

		methods: {
			gengxin(){
				this.loading = true
				this.xiaoxilist()
			},
			// 切换页面
			handleCurrentChange(val){
				this.page = val
				this.xiaoxilist()
			},
			xiaoxilist(){
				let url = ''
				let page = {
					page:this.page,
					list_rows:this.page_size
				}
				if(this.tabs == 1){
					url = this.$apiUrls.post6415752f56d0f
					page.category_id = 1
				}else if(this.tabs == 2){
					url = this.$apiUrls.post6424280846288
					page.msg_type = 2
				}
				this.$api.post(url,page).then((res) => {
					if(res.code == 1){
						this.order_list = res.data.data
						this.total = res.data.total
						this.loading = false
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 获取文章详情
			post641576c24de11(){
				this.$api.post(this.$apiUrls.post641576c24de11,{article_id: this.ping_id}).then((res) => {
					if(res.code == 1){
						this.detail = res.data
						this.tab_type = 2
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			caozuo(type,item){
				let url = ''
				if(type == 1){
					if(this.tab_type == 1){
						if(item == 1){
							window.history.back();
							return
						}
					}else if(this.tab_type == 2){
						this.tab_type = 1
					}
					
					// this.$router.push({
					// 	name: url,
					// });
				}else if(type == 2){
					
					this.tabs = item
					this.page = 1
					this.loading = true
					this.xiaoxilist()
				}else if(type == 3){
					if(this.tabs == 1){
						this.ping_id = item.aid
						this.post641576c24de11()
					}else{
						window.sessionStorage.setItem('order_id', item.order_id);
						window.sessionStorage.setItem('order_type', 2);
						this.$router.push({
							name: 'orderDetal',
						});
					}
					
				}
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-loading-mask {
			opacity: 1 !important; 
			background-color: rgba(255, 255, 255, 1) !important;
		}
	}
	.bind{
		margin-top: 20px;
		padding: 0 20px 100px;
		background: #fff;
	}
	.bind_1{
		padding: 20px 0;
		border-bottom: 1px solid #EEEEEE;
	}
	.bind_1_1{
		width: 14px;
		height: 14px;
	}
	.bind_1_2{
		font-weight: 500;
		font-size: 14px;
		color: #666666;
		margin-left: 10px;
	}
	.myNew_1{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
		margin: 16px 0 0 0;
	}
	.myNew_2{
		padding: 20px 0;
		border-bottom: 1px solid #EEEEEE;
	}
	.myNew_2_1{
		font-weight: bold;
		font-size: 14px;
		color: #FF770F;
	}
	.myNew_2_2{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
	}
	.myNew_2_3{
		margin: 0 56px 0 0;
	}
	.myNew_3{
		padding: 24px 0 20px 0;
		border-bottom: 1px solid #EEEEEE;
	}
	.myNew_3_1{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.myNew_3_2{
		font-weight: 400;
		font-size: 14px;
		color: #999999;
	}
	.myNew_3_3{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		margin: 10px 0 0 0;
	}
	.myNew_3_4{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
	}
	.myNew_3_5{
		font-weight: 400;
		font-size: 14px;
		color: #199DFF;
	}
	.myNew_4{
		width: 840px;
		font-weight: bold;
		font-size: 20px;
		color: #333333;
		margin: 24px 0 0 0;
		text-align: center;
	}
	.myNew_5{
		font-weight: 400;
		font-size: 14px;
		color: #999999;
		padding: 12px 0 30px 0;
		margin: 0 0 20px 0;
		width: 810px;
		text-align: center;
		border-bottom: 1px solid #EEEEEE;
	}
	.content-h{
		width: 810px;
	}
</style>